import { Reducer } from 'redux';
import { SubscriptionTypes, SubscriptionState } from './types';

export const initialState: SubscriptionState = {
  subscriptions: [],
  loading: false,
  // error: null,
};

const reducer: Reducer<SubscriptionState> = (state = initialState, action) => {
  switch (action.type) {
    case SubscriptionTypes.FETCH_USER_SUBSCRIPTION: {
      return { ...state, loading: true };
    }

    case SubscriptionTypes.UPDATE_USER_SUBSCRIPTION: {
      return { ...state, loading: true };
    }
    case SubscriptionTypes.FETCH_USER_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        subscriptions: [...action.payload.subscriptions],
      };
    }
    case SubscriptionTypes.FETCH_USER_SUBSCRIPTION_FAIL: {
      return {
        subscriptions: [],
        loading: false,
      };
    }
    case SubscriptionTypes.UPDATE_USER_SUBSCRIPTION_SUCCESS: {
      return {
        subscriptions: [],
        loading: false,
      };
    }
    case SubscriptionTypes.UPDATE_USER_SUBSCRIPTION_FAIL: {
      return {
        subscriptions: [],
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as SubscriptionReducer };
